module.exports = __webpack_public_path__ + "static/media/dingdong.a14cf047.mp3";